module.exports = __webpack_public_path__ + "img/input-file-plus.709d525a.svg";